import React from "react";
import { OverlayView } from "@react-google-maps/api";
import { toLatLngLiteral } from "../../utils/calculateDistance";

export default function SafeOverlayView({ position, children, ...rest }) {
  const coords = toLatLngLiteral(position);
  if (!coords) return null;

  return (
    <OverlayView position={coords} {...rest}>
      {children}
    </OverlayView>
  );
}
